import { Routes, Route } from "react-router-dom";
import { CampaignPropagationList } from "./index";
import { CampaignPropagationDetails } from "./details";

export default function CampaignPropagationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CampaignPropagationList />} />
      <Route path="/:type/:code" element={<CampaignPropagationDetails />} />
    </Routes>
  );
}
